// Toggle [elements] by className IN [elements]
let toggleNextEl = {
  inserted: (el, binding, vnode) => {
    el.onclick = function () {
      if (el.classList.contains('v-opened')) {
        el.classList.remove('v-opened');
        el.nextElementSibling.style.overflowY = 'hidden'
        el.nextElementSibling.style.height = 0;
      } else {
        el.classList.add('v-opened');
        let elHeight = el.nextElementSibling.scrollHeight;
        el.nextElementSibling.style.height = elHeight + 'px';
      }
    }

    if (!el.classList.contains('v-opened')) {
      el.nextElementSibling.style.height = 0;
      el.nextElementSibling.style.overflowY = 'hidden'
    } else {
      let startHeight = el.nextElementSibling.scrollHeight;
      el.nextElementSibling.style.height = startHeight + 'px';
    }
  }
}


const directives = {
  toggleNextEl
}
export default directives